export const paymentFooterContent = {
    'cottages.com': {
        helpSection: {
            title: 'Need help?',
            text: 'Our team will be happy to assist.',
            cta: '0345 498 6900',
            openingTimes: 'Open 8:30am-9pm today.',
        },
        paymentSection: {
            title: 'We accept the following payment types.',
            text: 'Membership numbers Y0662/L4801.',
        },
        companyName: 'Cottages.com',
        termsAndConditions: {
            displayText: 'Terms and Conditions*',
            href: '/legal/booking-conditions',
            openInNew: true,
        },
    },
};
//# sourceMappingURL=payments-footer.data.js.map